// Modelo AUTORAL da cruzada tradicional (dicas numa lista, não nas casas).
// Coordenadas 0-based: x = coluna, y = linha. direcao false = horizontal.

export interface TraditionalWord {
  /** 'w17' no import; 'p123' para palavra do banco. */
  key: string;
  /** id da palavra no banco (null antes de criar). */
  id: number | null;
  texto: string;
  x: number;
  y: number;
  direcao: boolean;
  chave: string;
}

export interface TraditionalDoc {
  titulo: string;
  largura: number;
  altura: number;
  casasPretas: { x: number; y: number }[];
  palavras: TraditionalWord[];
}

export function emptyTraditionalDoc(titulo = ""): TraditionalDoc {
  return { titulo, largura: 0, altura: 0, casasPretas: [], palavras: [] };
}

/** Quantas palavras já têm dica (ignorando espaços). */
export function countFilled(doc: TraditionalDoc): number {
  return doc.palavras.filter((w) => w.chave.trim() !== "").length;
}
